export const colors = {
	PURPLE: '#3c228a',
	DARK_PURPULE_NEW: '#3A1D93',
	DARK_PURPULE: '#13014a',
	PURPLE_ACTIVE: '#3c228a',
	PURPLE_INACTIVE: '#9d90c4',
	PURPLE_LIGHT: 'rgba(60, 34, 138, 0.16)',
	PURLPE_BACKGROUND: '#9587bf',
	PURPLE_AI: '#6245B7',
	WHITE: '#ffffff',
	BOLD_WHITE: '#FAFAFA',
	LIGHT_GREY: '#dadce0',
	LIGHT_GREY1: '#D5D6D8',
	LIST_CLR: '#2E2F32',
	LIST_BORDER_CLR: '#E3E4E5',
	MID_GREY: '#B2B0B9',
	DISABLE_GREY: '#BABBBE',
	GREY: '#6d6e71',
	DARK_GREY: '#2E2F32',
	BLACK: '#000000',
	LIGHT_GRAY_SHADE: '#F2F2F2',
	LIGHT_GRAY_SHADE_1: '#F1F1F2',
	DARK_GRAY_SHADE: '#565656',
	HOVER_GRAY_SHADE: '#f9f9f9',
	ERROR: '#cb2022',
	VOLT: '#eaf100',
	INACTIVE: '#7b7297',
	LIGHT_BLUE: '#a8b7e9',
	BLUE_ACTIVE: '#0e4fbd',
	BLUE_INACTIVE: '#86a7dd',
	MAGENTA_ACTIVE: '#a20081',
	MAGENTA_INACTIVE: '#d07fc0',
	PINK_ACTIVE: ' #e21b63',
	PINK_INACTIVE: ' #f08cb1',
	ORANGE_ACTIVE: '#ff623c',
	ORANGE_INACTIVE: '#feb09d',
	FONT_COLOR: '#333333',
	FONT_COLOR_SECONDARY: '#5F6367',
	OFF_WHITE: '#ffffff',
	POSITIVE_GROWTH_COLOR: '#0F9D58',
	NEGATIVE_GROWTH_COLOR: '#CB2022',
	PIE_SERIES_COLOR: '#9D90C4',
	PIE_SERIES_COLOR1: '#9B91C0',
	PIE_SERIES_COLOR2: '#634EA1',
	PIE_SERIES_COLOR3: '#EBE9F3',
	PIE_SERIES_COLOR4: '#372785',
	TOGGLE_ACTIVE: '#EBE8F3',
	COLUMN_SERIES: '#E4E1EE',
	LIGHT_PURPLE: '#7063A6',
	LIGHT_BLUE_MAGENTA: '#9283BE',
	BOLD_BLACK: '#282828',
	SUCCESS_HIGH: '#1D5F02',
	SUCCESS_MD: '#2A8703',
	SUCCESS_MIN: '#EAF3E6',
	ERROR_HIGH: '#9B1419',
	ERROR_MD: '#DE1C24',
	ERROR_MIN: '#FCE8E9',
	ERROR_LIGHT_HIGHLIGHT: '#FEF6F6',
	PURPLE_HOVER: '#D1CBE4',
	ERROR_LIGHT: '#EF8E92',
	WARNING_HIGH: '#662B0D',
	WARNING_MD: '#FFC220',
	WARNING_MIN: '#FFF9E9',
	WARNING_LIGHT: '#FFE190',
	WHITE_OPACITY_8: 'rgba(255, 255, 255, 0.8)',
	WHITE_OPACITY_7: 'rgba(255, 255, 255, 0.7)',
	CYAN_OPACITY_2: 'rgba(24, 144, 255, 0.2)',
	GRAY_OPACITY_1: 'rgba(46, 47, 50, 1)',
	GRAY_OPACITY_8: 'rgba(0,0,0,.85)',
	ASH_OPACITY_1: 'rgba(227, 228, 229, 1)',
	PURPLE_MAJESTY_LITE: '#8879B9',
	LIGHT_GRAY_SHADE_HEX: '#EEE',
	DARK_ASH: '#818386',
	LIGHT_ASH: '#d9d9d9',
	DARK_GRAY_NEW: '#434343',
	LIGHT_BLACK: '#141414',
	SKY_BLUE: '#177ddc',
	BREADCRUMB_INACTIVE: '#74767C',
	BREADCRUMB_ACTIVE: '#000000',
	CYAN: '#40a9ff',
	DARK_GRAY_THREE: '#303030',
	LIGHT_ASH_EIGHT: '#E8E8E8',
	DARK_BLUE: '#003b57',
	CYAN_TWO: '#e6f7ff',
	PURPLE_GRAY: '#c7c8cb',
	WHITE_GREY: '#F8F8F8',
	ORANGE: '#FB8333',
	MAKO: '#515357',
	LIGHT_ORANGE: '#FED1B3',
	CHANNEL_BREAKDOWN: {
		BIS: '#3C228A',
		PU: '#8272B4',
		DLV: '#D0CAE3',
		SFS: '#CECECE',
		S2S: '#333333',
		S2H: '#7C7C7C',
	},
	HEATMAP: {
		// Colors in the order from light to darker
		POSITIVE_COLORS: ['#D4E7CD', '#3F931C', '#154402'],
		RGB_POSITIVE_COLORS: ['212,231,205', '63,147,28', '21,68,2'],
		// Colors in the order from dark to lighter
		NEGATIVE_COLORS: ['#6F0E12', '#E54950', '#F8D2D3'],
		RGB_NEGATIVE_COLORS: ['111,14,18', '229,73,80', '248,210,211'],
	},
	TOOLTIP: {
		BG: '#3A1D93',
		HOT_SPOT: {
			BG: '#6848C8',
		},
	},
	LIGHT_GRAY_HEX: '#74767C',
	ALERT_BORDER: '#B5ABD3',
	ALERT_TEXT_COLOR: '#2E2F32',
	SHIMMER_UI_GREY: '#E6E6E6',
};
